import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UzurvPipesModule } from '@uzurv/core';
import { DocumentFileDirective } from './document-file/document-file.directive';
import { DriverProfilePictureDirective } from './driver-profile-picture/driver-profile-picture.directive';
import { VehicleImageDirective } from './vehicle-image/vehicle-image.directive';

@NgModule({
    imports: [CommonModule, UzurvPipesModule, DriverProfilePictureDirective, DocumentFileDirective, VehicleImageDirective],
    providers: [],
    exports: [DriverProfilePictureDirective, DocumentFileDirective, VehicleImageDirective]
})
export class DotsDirectivesModule {}
